module.exports = __webpack_public_path__ + "img/65.cc714485.jpg";